import type { ReactNode } from 'react'

import styles from './Feedback.module.css'

interface ListRowProps {
  readonly title: ReactNode
  readonly subtitle?: ReactNode
  readonly leading?: ReactNode
  readonly trailing?: ReactNode
  readonly onClick?: () => void
}

/**
 * One row of a list.
 *
 * Renders a `<button>` when it navigates and a `<div>` when it does not, for
 * the same reason `Chip` does: a clickable non-button is invisible to keyboard
 * and screen-reader users, and this app's primary lists are its main
 * navigation.
 */
export function ListRow({ title, subtitle, leading, trailing, onClick }: ListRowProps) {
  const content = (
    <>
      {leading}
      <span className={styles['rowMain']}>
        <span className={styles['rowTitle']}>{title}</span>
        {subtitle !== undefined && (
          <span className={styles['rowSubtitle']}>{subtitle}</span>
        )}
      </span>
      {trailing !== undefined && (
        <span className={styles['rowTrailing']}>{trailing}</span>
      )}
    </>
  )

  if (!onClick) {
    return <div className={styles['row']}>{content}</div>
  }

  return (
    <button
      type="button"
      className={`${styles['row']} ${styles['rowInteractive']}`}
      onClick={onClick}
    >
      {content}
    </button>
  )
}
